import { GoustoLink } from './Link'
export default GoustoLink
